import type { Persona } from '../types/persona';

export type PersonaQualityTier = 'forged' | 'draft' | 'bare';

/**
 * Walks persona's nested engineering_profile to determine quality tier.
 * Lifted from frontend/src/pages/Personas.tsx:287 (the canonical inline
 * definition with 4 internal call sites). Personas.tsx migrated to import
 * from this module in the same commit.
 *
 * forged: system_prompt compiled (operator can chat with full Forge persona)
 * draft:  character_bible authored but system_prompt not yet compiled
 * bare:   minimal metadata only (no Forge work yet)
 */
export function getPersonaQualityTier(p: Persona): PersonaQualityTier {
  const pa = p as any;
  const forge =
    pa?.data?.engineering_profile?.current_state
    ?? pa?.data?.data?.engineering_profile?.current_state
    ?? null;
  if (forge?.system_prompt) return 'forged';
  if (forge?.character_bible) return 'draft';
  return 'bare';
}
